// Arabisch (ar), design: zelfde vorm als design.nl.ts. Pictogramnamen als korte zelfstandige
// naamwoorden (masdar), eenvoudig voor kinderen. Zoekwoorden: Arabisch plus de bestaande Latijnse
// woorden (gezinnen typen titels vaak in het Nederlands of Turks).
export const designAr = {
    picto: {
        'brush-teeth': 'تنظيف الأسنان',
        'get-dressed': 'ارتداء الملابس',
        shoes: 'لبس الحذاء',
        coat: 'لبس الجاكيت',
        'wash-hands': 'غسل اليدين',
        toilet: 'دورة المياه',
        shower: 'الاستحمام',
        bath: 'حوض الاستحمام',
        sleep: 'النوم',
        alarm: 'المنبّه',
        prayer: 'الصلاة',
        wudu: 'الوضوء',
        'make-bed': 'ترتيب السرير',
        'tidy-up': 'الترتيب',
        'set-table': 'تجهيز المائدة',
        'clear-table': 'رفع المائدة',
        dishes: 'غسل الصحون',
        dishwasher: 'تفريغ غسالة الصحون',
        vacuum: 'الكنس بالمكنسة',
        sweep: 'الكنس',
        cleaning: 'التنظيف',
        windows: 'تنظيف النوافذ',
        laundry: 'تشغيل الغسالة',
        'fold-laundry': 'طي الغسيل',
        trash: 'إخراج القمامة',
        recycling: 'فرز النفايات',
        'water-plants': 'سقي النباتات',
        garden: 'الحديقة',
        'walk-dog': 'تمشية الكلب',
        'feed-cat': 'إطعام القطة',
        'feed-fish': 'إطعام السمك',
        'feed-rabbit': 'إطعام الأرنب',
        mail: 'البريد',
        school: 'المدرسة',
        backpack: 'حقيبة المدرسة',
        homework: 'الواجبات',
        reading: 'القراءة',
        library: 'المكتبة',
        lecture: 'محاضرة',
        mosque: 'درس المسجد',
        quran: 'القرآن',
        computer: 'الحاسوب',
        work: 'العمل',
        'phone-call': 'مكالمة',
        calendar: 'موعد',
        soccer: 'كرة القدم',
        hockey: 'الهوكي',
        swimming: 'السباحة',
        gymnastics: 'الجمباز',
        dance: 'الرقص',
        ballet: 'الباليه',
        tennis: 'التنس',
        basketball: 'كرة السلة',
        judo: 'الجودو',
        'horse-riding': 'ركوب الخيل',
        skating: 'التزلج',
        running: 'الجري',
        cycling: 'ركوب الدراجة',
        playground: 'ساحة اللعب',
        'music-lesson': 'درس الموسيقى',
        piano: 'البيانو',
        guitar: 'الغيتار',
        violin: 'الكمان',
        drums: 'الطبول',
        singing: 'الغناء',
        theater: 'المسرح',
        drawing: 'الرسم',
        painting: 'التلوين',
        crafts: 'الأشغال اليدوية',
        puzzle: 'الألغاز',
        play: 'اللعب',
        gaming: 'ألعاب الفيديو',
        tv: 'مشاهدة التلفاز',
        'screen-time': 'وقت الشاشة',
        dentist: 'طبيب الأسنان',
        doctor: 'الطبيب',
        hospital: 'المستشفى',
        medicine: 'الدواء',
        sick: 'مريض',
        haircut: 'الحلاق',
        birthday: 'عيد الميلاد',
        party: 'حفلة',
        gift: 'هدية',
        wish: 'أمنية',
        chat: 'الرسائل',
        sohbet: 'صحبة',
        grandma: 'الجدة',
        grandpa: 'الجد',
        family: 'العائلة',
        babysitter: 'جليسة الأطفال',
        playdate: 'موعد لعب',
        sleepover: 'مبيت عند الأصدقاء',
        home: 'البيت',
        holiday: 'العطلة',
        travel: 'السفر',
        camping: 'التخييم',
        zoo: 'حديقة الحيوان',
        museum: 'المتحف',
        cinema: 'السينما',
        car: 'السيارة',
        bus: 'الحافلة',
        train: 'القطار',
        walk: 'المشي',
        church: 'الكنيسة',
        shabbat: 'السبت (شبات)',
        synagogue: 'الكنيس',
        mandir: 'المعبد الهندوسي',
        moon: 'الهلال',
        breakfast: 'الفطور',
        lunch: 'الغداء',
        dinner: 'العشاء',
        fruit: 'الفاكهة',
        drink: 'الشرب',
        cooking: 'الطبخ',
        baking: 'الخَبز',
        groceries: 'التسوق',
        'ice-cream': 'مثلجات',
        popcorn: 'سهرة فيلم',
        pizza: 'بيتزا',
        pancakes: 'بان كيك',
        soup: 'حساء',
        'oven-dish': 'صينية فرن',
        stamppot: 'ستامبوت',
        lasagne: 'لازانيا',
        curry: 'كاري',
        noodles: 'نودلز',
        taco: 'تاكو',
        wrap: 'لفائف',
        salad: 'سلطة',
        hamburger: 'همبرغر',
        fries: 'بطاطا مقلية',
        dumplings: 'فطائر محشوة',
        waffle: 'وافل',
        pie: 'فطيرة حلوة',
        cake: 'حلويات',
        pudding: 'تحلية',
        banana: 'موز',
        pear: 'إجاص',
        orange: 'برتقال',
        lemon: 'ليمون',
        strawberry: 'فراولة',
        grapes: 'عنب',
        tomato: 'طماطم',
        cucumber: 'خيار',
        carrot: 'جزر',
        broccoli: 'بروكلي',
        lettuce: 'خس',
        'bell-pepper': 'فلفل حلو',
        onion: 'بصل',
        garlic: 'ثوم',
        potato: 'بطاطا',
        mushroom: 'فطر',
        corn: 'ذرة',
        avocado: 'أفوكادو',
        cheese: 'جبن',
        butter: 'زبدة',
        egg: 'بيض',
        yoghurt: 'لبن زبادي',
        croissant: 'كرواسون',
        honey: 'عسل',
        meat: 'لحم',
        chicken: 'دجاج',
        bacon: 'لحم مقدد',
        fish: 'سمك',
        shrimp: 'روبيان',
        sausage: 'نقانق',
        rice: 'أرز',
        salt: 'ملح',
        'canned-food': 'معلبات',
        peanuts: 'فول سوداني',
        chocolate: 'شوكولاتة',
        cookie: 'بسكويت',
        jar: 'مرطبان',
        coffee: 'قهوة',
        tea: 'شاي',
        juice: 'عصير',
        water: 'ماء',
        'toilet-paper': 'ورق الحمام',
        soap: 'صابون',
        sponge: 'إسفنجة',
        basket: 'سلة',
        'baby-bottle': 'طعام الرضيع',
        receipt: 'إيصال',
        store: 'متجر',
        star: 'نجمة',
        trophy: 'كأس',
        medal: 'ميدالية',
        savings: 'الادخار',
        fox: 'ثعلب',
        cat: 'قطة',
        rabbit: 'أرنب',
        bear: 'دب',
        panda: 'باندا',
        koala: 'كوالا',
        owl: 'بومة',
        lion: 'أسد',
        tiger: 'نمر',
        monkey: 'قرد',
        unicorn: 'حصان وحيد القرن',
        dino: 'ديناصور',
        turtle: 'سلحفاة',
        frog: 'ضفدع',
        hedgehog: 'قنفذ',
        penguin: 'بطريق',
        dolphin: 'دلفين',
        butterfly: 'فراشة',
        rocket: 'صاروخ',
        sunflower: 'عباد الشمس',
        rainbow: 'قوس قزح',
        // Thema's (feat/themas): rustige, abstracte avatars.
        'shape-arch': 'قوس',
        'shape-wave': 'أمواج',
        'shape-leaf': 'ورقة',
        'shape-hills': 'تلال',
        'shape-ring': 'حلقة',
        'shape-spark': 'شرارة',
        towel: 'منشفة',
        underwear: 'ملابس داخلية',
        socks: 'جوارب',
        'swim-trunks': 'شورت سباحة',
        swimsuit: 'لباس سباحة',
        shampoo: 'شامبو',
        slippers: 'شبشب',
        'football-boots': 'حذاء كرة القدم',
        'shin-guards': 'واقي الساق',
        'water-bottle': 'قارورة ماء',
        headscarf: 'حجاب',
        'prayer-cap': 'طاقية',
    },
    pictoKeywords: {
        // Oprichter 1 okt: lezing, en sohbet (alleen bij Turks én Islam in het gezinsprofiel).
        lecture: 'محاضرة ندوة lecture lezing ders vortrag conference',
        sohbet: 'صحبة sohbet sohbeti muhabbet',
        mosque: 'مسجد جامع درس_المسجد تحفيظ قرآن عربي moskee moskeeles masjid islam koran koranles arabisch camii cami_ders kuran hafizlik',
        prayer: 'صلاة صلوات دعاء تراويح bidden gebed namaz salah salat teravih dua',
        wudu: 'وضوء الوضوء wudu wudhu woedoe abdest abdest_almak wudu_doen',
        quran: 'قرآن القرآن تحفيظ تجويد حفظ koran koranles kuran quran hafiz hifz tajwid',
        church: 'كنيسة قداس مسيحي kerk kerkdienst christelijk kapel',
        shabbat: 'سبت شبات يهودي sjabbat shabbat sabbat joods',
        synagogue: 'كنيس يهودي synagoge sjoel joods',
        mandir: 'معبد هندوسي بوجا mandir tempel hindoe puja',
        moon: 'قمر هلال رمضان maan maansikkel halve_maan ramadan',
        towel: 'منشفة فوطة handdoek',
        underwear: 'ملابس_داخلية ملابس onderbroek ondergoed',
        socks: 'جوارب جورب sokken sok',
        'swim-trunks': 'شورت_سباحة سباحة zwembroek',
        swimsuit: 'لباس_سباحة مايوه بوركيني badpak zwempak bikini',
        shampoo: 'شامبو صابون جل_استحمام shampoo douchegel zeep',
        slippers: 'شبشب نعال slippers teenslippers badslippers',
        'football-boots': 'حذاء_كرة_القدم حذاء voetbalschoenen kicksen noppen',
        'shin-guards': 'واقي_الساق واقي scheenbeschermers scheenbeschermer',
        'water-bottle': 'قارورة_ماء قارورة زجاجة_ماء bidon drinkfles waterfles',
        headscarf: 'حجاب خمار وشاح hoofddoek hijab sjaal',
        'prayer-cap': 'طاقية طاقية_الصلاة كوفية takke gebedsmuts kufi muts',
    },
    pictoCategory: {
        routine: 'روتين اليوم',
        chores: 'أعمال المنزل',
        school: 'المدرسة والعمل',
        sport: 'الرياضة',
        hobby: 'الموسيقى والهوايات',
        care: 'الرعاية',
        family: 'العائلة والنزهات',
        food: 'الطعام',
        groceries: 'التسوق',
        reward: 'المكافأة',
        avatar: 'حيوانات وشخصيات',
        packing: 'تجهيز الحقيبة',
    },
    color: {
        orange: 'برتقالي',
        skyblue: 'أزرق فاتح',
        bluishgreen: 'أخضر',
        yellow: 'أصفر',
        blue: 'أزرق',
        vermillion: 'أحمر',
        reddishpurple: 'وردي',
        black: 'رمادي',
    },
    eventCard: {
        allDay: 'طوال اليوم',
        cancelled: 'أُلغي',
        everyone: 'الجميع',
        whoDrives: 'من يوصل؟',
        drives: 'التوصيل: {name}',
        splitDrives: 'الذهاب: {dropoff} · العودة: {pickup}',
        repeat: 'يتكرر',
        moved: 'تغيّر موعده',
        changed: 'تغيّر',
    },
    check: {
        label: '{task}: انتهيت؟',
        confirm: 'انتهيت!',
        undo: 'تراجع',
    },
    points: {
        earned: {
            zero: '{count} نقطة',
            one: 'نقطة واحدة',
            two: 'نقطتان',
            few: '{count} نقاط',
            many: '{count} نقطة',
            other: '{count} نقطة',
        },
        reserved: '{count} محجوزة',
    },
    progress: '{done} من {total} تمّت',
    celebrate: {
        task: 'أحسنت يا {name}!',
        allDone: 'انتهى كل شيء!',
        /** Rustig, buiten het thema Kinderen (oprichter okt 2026: geen uitroeptekens of lof). */
        calm: {
            confirm: 'تم',
            task: 'أنجزها {name}',
            allDone: 'اكتمل كل شيء لهذا اليوم',
        },
    },
    colorPicker: {
        label: 'اللون',
        takenBy: 'اختاره {name}',
        takenOne: '{color} محجوز لـ {name}',
    },
    iconPicker: {
        label: 'الرمز',
        search: 'ابحث عن رمز',
        none: 'بلا رمز',
        noResults: 'لا نتائج لـ «{query}»',
        all: 'الكل',
        more: '+{count} أخرى',
    },
    toast: {
        undo: 'تراجع',
        dismiss: 'إغلاق التنبيه',
    },
    dialog: {
        close: 'إغلاق',
        fullScreen: 'ملء الشاشة',
        smallScreen: 'تصغير',
    },
    calendar: {
        weekShort: 'أسبوع',
        more: '+{count} أخرى',
        moreShort: '+{count}',
        now: 'الآن',
    },
    editor: {
        title: 'العنوان',
        titleHint: 'قصير وواضح، مثلًا: درس السباحة',
        repeat: 'التكرار',
        repeatNone: 'بدون تكرار',
        repeatDaily: 'كل يوم',
        repeatWeekly: 'كل أسبوع يوم {weekday}',
        repeatMonthly: 'كل شهر',
        duplicate: 'نسخ',
        approvalRequired: 'تحتاج موافقة',
        approvalHint: 'يوافق بابا أو ماما على المهمة قبل احتساب النقاط.',
        deleteQuestion: 'حذف {title}؟',
        repeatsWeekly: 'هذا الموعد يتكرر كل أسبوع.',
    },
    scope: {
        editTitle: 'ماذا تريد أن تغيّر؟',
        deleteTitle: 'ماذا تريد أن تحذف؟',
        this: 'هذه المرة فقط',
        following: 'هذه والمرات التالية',
        all: 'السلسلة كلها',
        times: {
            zero: '{count} مرة',
            one: 'مرة واحدة',
            two: 'مرتان',
            few: '{count} مرات',
            many: '{count} مرة',
            other: '{count} مرة',
        },
        from: 'من {date}',
    },
    view: {
        label: 'العرض',
        day: 'يوم',
        week: 'أسبوع',
        month: 'شهر',
    },
    inbox: {
        label: 'الموافقات',
        open: 'بانتظار الرد',
        done: 'تمت معالجتها',
    },
    empty: {
        welcomeTitle: 'أهلًا بكم في البيت',
        welcomeBody: 'نرى الأسبوع معًا، بلا تعب. نبدأ بعائلتك.',
        emptyDayTitle: 'لا شيء مخطط اليوم',
        emptyDayBody: 'يوم هادئ. ما رأيكم بشيء ممتع؟',
        noTasksTitle: 'لا مهام اليوم',
        noTasksBody: 'يوم حر!',
        allDoneTitle: 'اكتمل كل شيء',
        allDoneBody: 'لم يبقَ شيء مفتوح.',
        offlineTitle: 'لا يوجد اتصال الآن',
        offlineBody: 'ترى آخر حالة محفوظة. سيعود الاتصال من تلقاء نفسه.',
        nightTitle: 'تصبحون على خير',
        nightBody: 'غدًا الساعة {time}: {title}',
        rewardsTitle: 'لا مكافآت بعد',
        rewardsBody: 'فكّروا معًا في شيء تدّخرون له.',
        inviteTitle: 'ادعُ شريكك',
        inviteBody: 'التخطيط معًا أسهل. أرسل دعوة بالبريد الإلكتروني.',
        oopsTitle: 'عذرًا، حدث خطأ',
        oopsBody: 'حاول مرة أخرى. إن لم ينجح ذلك، أعد تحميل الصفحة.',
        pairTitle: 'اربط الجهاز اللوحي',
        pairBody: 'افتح لوحة العائلة على الجهاز اللوحي وأدخل الرمز هنا.',
    },
    credits: 'الرموز والأيقونات والرسوم: AMUMIN',
    gallery: {
        title: 'معرض التصميم',
        intro: 'كل عناصر لوحة العائلة في مكان واحد: القيم الأساسية والمكونات والأيقونات والرموز والرسوم. يظهر في بيئة التطوير فقط.',
        theme: 'المظهر',
        themeLight: 'نهار',
        themeDark: 'مساء',
        themeNight: 'ليل',
        colors: 'الألوان',
        memberColors: 'ألوان الأفراد',
        neutrals: 'الألوان المحايدة',
        semantic: 'ألوان المعنى',
        typography: 'الخطوط',
        spacing: 'المسافات والأشكال',
        kiosk: 'عناصر اللوحة الجدارية',
        web: 'عناصر تطبيق الويب',
        icons: 'الأيقونات',
        pictograms: 'الرموز',
        illustrations: 'الرسوم',
        sample: 'مثال',
    },
};
//# sourceMappingURL=design.ar.js.map